<template>
  <div>
    <div class="page-header d-flex justify-content-between align-items-start">
      <h3>
        <i class="material-icons">inventory_2</i>
        File Cabinet
      </h3>
    </div>

    <ul class="mt-2 list-group">
      <draggable v-model="fileCabinetFolders" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="folder in fileCabinetFolders" :key="folder.id" class="list-group-item">
            <div class='float-right d-flex align-items-center'>
              <i class="material-icons pointer ml-1 sort-handle">reorder</i>
            </div>
            <div>
              <i class="material-icons pointer ml-1 sort-handle">folder</i>
              <span class="align-top">
                {{folder.name}}
              </span>
            </div>
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import api from "api";
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  computed: {
    fileCabinetFolders: {
      set: function(value){
        value.forEach(function(item, index){
          api.updateProject(item.id, { sort: index })
        })

        return value;
      },
      get() {
        if(this.$store.state.project_areas.length > 0){
          return this.$store.state.project_areas.filter(area => {
            return area.file_cabinet === true
          })[0].projects.sort(firstBy("sort"))
        }
      }
    },
  }
}
</script>
